export default function isRTL() {
  return typeof window !== 'undefined' && (document.body.getAttribute('dir') || document.dir) === 'rtl';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/es/utils/isRTL.js
// module id = 1035
// module chunks = 33